export default __webpack_public_path__ + "static/media/bias_tape.d6b7390e.jpg";